class FabricInfoDrawer extends HTMLElement {
  constructor() {
    super();
    this._overlay = this.querySelector(".fabric-drawer__overlay");
    this._titleEl = this.querySelector(".fabric-drawer__title");
    this._contentEl = this.querySelector(".fabric-drawer__content");
    this._closeBtn = this.querySelector(".drawer__close");

    if (this._overlay) {
      this._overlay.addEventListener("click", () => this.close());
    }
    if (this._closeBtn) {
      this._closeBtn.addEventListener("click", () => this.close());
    }
    this.addEventListener("keyup", (evt) => {
      if (evt.code === "Escape") this.close();
    });
  }

  open(blockIndex) {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;
    const template = document.getElementById(
      `fabric-drawer-template-${sectionId}-${blockIndex}`
    );
    if (!template) return;

    const scrollY = window.scrollY || document.documentElement.scrollTop;
    this._savedScrollY = scrollY;

    const title = template.dataset.title || "";
    const body = template.content.cloneNode(true);

    if (this._titleEl) this._titleEl.textContent = title;
    if (this._contentEl) {
      this._contentEl.innerHTML = "";
      this._contentEl.appendChild(body);
    }

    document.body.style.top = `-${scrollY}px`;
    document.body.style.position = "fixed";
    document.body.style.width = "100%";

    this.classList.add("animate", "active");
    document.body.classList.add("cart-overflow-hidden");
    if (typeof isSafari === "function" && !isSafari()) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.add("overflow-clip");
    }

    this.addEventListener(
      "transitionend",
      () => {
        const inner = this.querySelector(".drawer__inner");
        const focusEl = this.querySelector(".drawer__close");
        if (typeof trapFocus === "function" && inner) {
          trapFocus(inner, focusEl);
        }
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove("active");
    if (this._activeElement && typeof removeTrapFocus === "function") {
      removeTrapFocus(this._activeElement);
    }
    document.body.classList.remove("cart-overflow-hidden", "overflow-hidden", "overflow-clip");

    const savedY = this._savedScrollY;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    if (savedY != null) {
      this._savedScrollY = null;
      window.scrollTo(0, savedY);
    }
  }
}

customElements.define("fabric-info-drawer", FabricInfoDrawer);
